<template>
  <v-table class="mt-1" width="100%">
    <thead>
      <tr>
        <th style="color: #333;">SN</th>
        <th style="color: #333;">Code</th>
        <th style="color: #333;">Item</th>
          <th class="text-center" style="color: #333;">Unit</th>
        <th style="color: #333;">Lot No.</th>
        <th class="text-center" style="color: #333;">Quantity</th>
        <th class="text-center" style="color: #333;">Free Quantity</th>
      
        <th class="text-center" style="color: #333;">Sales Rate</th>
        <th class="text-center" style="color: #333;">Pur. Rate</th>
        <th class="text-right" style="color: #333;">Amount</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(product, key) in poReceiveData?.inv_po_receive_details" :key="product.product_id || key">
        <td style="color: #555;">{{ key + 1 }}</td>
        <td style="color: #555;">{{ product?.product?.code || '' }}</td>
        <td style="color: #555;">{{ product?.product?.name || '' }}</td>
          <td class="text-center" style="color: #555;">{{ product?.product?.unit?.name || '' }}</td>
        <td style="color: #555;">{{ product.lot_no || '' }}</td>
        <td class="text-center" style="color: #555;">{{ product?.qty || 0 }}</td>
        <td class="text-center" style="color: #555;">{{ product?.free_qty || 0 }}</td>
        
        <td class="text-center" style="color: #555;">{{ $numberFormat(product?.sales_rate || 0) }}</td>
        <td class="text-center" style="color: #555;">{{ $numberFormat(product?.rate || 0) }}</td>
        <td class="text-right" style="color: #555;">{{ $numberFormat(product?.total || (product?.qty * product?.rate) || 0) }}</td>
      </tr>
      <tr v-if="poReceiveData?.inv_po_receive_details?.length === 0">
        <td colspan="7" class="text-center" style="color: red;">
          No product details found
        </td>
      </tr>
    </tbody>
  </v-table>
  <v-row class="py-10">
    <v-col cols="9">
      <p class="text-right" style="color: #555;">TOTAL AMOUNT</p>
      <v-row class="font-weight-bold justify-space-between px-3 py-4">
        <p colspan="3" style="color: #333;"><strong>{{ convertNumberToWords(poReceiveData?.amount || 0) }}</strong></p>
      </v-row>
    </v-col>
    <v-col cols="3">
      <p class="text-right" style="color: #555;">{{ $numberFormat(poReceiveData?.amount || 0) }}</p>
    </v-col>
  </v-row>
  <v-row class="py-5" v-if="remarks">
    <v-col cols="12">
      <p style="color: #555;"><strong>Remarks:</strong> {{ remarks }}</p>
    </v-col>
  </v-row>  
</template>

<script>
import convertNumberToWords from '@/plugins/numberToWord';

export default {
  name: "slsPoReceiveDetailsTable",
  data() {
    return {
      poReceiveData: null,
      cart: []
    };
  },
  
  computed: {},
  watch: {},
  created() {},
  methods: {
    convertNumberToWords
  },
  setup(props, { emit }) { },
  
  mounted() {
    const id = this.$route.query.referenceable_id;

    this.$store.dispatch('getInvPoReceiveById', id)
      .then((res) => {
        this.poReceiveData = res;
        console.log(res)
      })

  },
};  

</script>

<style scoped>
.full-height {
  min-height: 60vh;
}

.grey-lighten-3 {
  background-color: #eeeeee !important;
}

.report-paper {
  background: white;
}

.company-name {
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
}

.company-text {
  font-size: 14px;
}

.report-title {
  font-size: 20px;
  text-align: center;
  margin: 8px 0;
}

.meta-box {
  border: 1px solid #000 !important;
  padding: 8px;
  font-size: 13px;
  margin: 8px 0;
}

.meta-table {
  width: 100%;
  border-collapse: collapse;
  
}

.dep-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.dep-table th,
.dep-table td {
  border: 1px solid #000;
  padding: 6px;
}

.dep-table th {
  background: #e0e0e0;
}

.total-section {
  margin: 20px 0;
}

.total-table {
  width: 100%;
  margin-bottom: 20px;
}

.remarks-section {
  margin: 20px 0;
  padding: 10px;
  border: 1px solid #ddd;
}

.signature-section {
  margin-top: 50px;
}

.signature-line {
  border-top: 1px solid #555;
  width: 200px;
  margin: 0 auto;
  text-align: center;
  color: #333;
  padding-top: 10px;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.supplier-name {
  font-weight: bold;
}

.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
  opacity: 0.1;
}

.page-header {
  margin-bottom: 20px;
}

.header-section {
  margin-bottom: 20px;
}

.company-info {
  flex: 1;
}

.logo-container {
  flex-shrink: 0;
}

.d-print-none {
  display: block !important;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>